import { lazy, Suspense } from "react";

import { SparkIcon } from "@/components/icons";
import { RequirePermission } from "@/components/RequirePermission";
import { ROUTES } from "@/config/routes";
import type { FeatureModule } from "@/types/feature";

const AssessmentDashboard = lazy(() =>
  import("./AssessmentDashboard").then((m) => ({ default: m.AssessmentDashboard }))
);
const AssessmentForm = lazy(() =>
  import("./AssessmentForm").then((m) => ({ default: m.AssessmentForm }))
);
const AssessmentResults = lazy(() =>
  import("./AssessmentResults").then((m) => ({ default: m.AssessmentResults }))
);
const AssessmentAdmin = lazy(() =>
  import("./AssessmentAdmin").then((m) => ({ default: m.AssessmentAdmin }))
);
const AssessmentUserDetail = lazy(() =>
  import("./AssessmentUserDetail").then((m) => ({ default: m.AssessmentUserDetail }))
);

function Loader() {
  return <div style={{ padding: 20, color: "var(--text-muted)", fontSize: 14 }}>Loading...</div>;
}

function wrap(Component: React.LazyExoticComponent<React.ComponentType>) {
  return (
    <Suspense fallback={<Loader />}>
      <Component />
    </Suspense>
  );
}

export const aiAssessmentFeature: FeatureModule = {
  id: "ai-assessment",
  navItems: [
    {
      id: "ai-assessment",
      label: "AI Assessment",
      path: ROUTES.aiAssessment,
      icon: SparkIcon,
    },
  ],
  routes: [
    { path: ROUTES.aiAssessment, element: wrap(AssessmentDashboard) },
    { path: ROUTES.aiAssessmentTake, element: wrap(AssessmentForm) },
    { path: ROUTES.aiAssessmentResults, element: wrap(AssessmentResults) },
    {
      path: ROUTES.aiAssessmentAdmin,
      element: (
        <RequirePermission perm="assessment.analytics.view" redirectTo={ROUTES.aiAssessment}>
          <Suspense fallback={<Loader />}>
            <AssessmentAdmin />
          </Suspense>
        </RequirePermission>
      ),
    },
    {
      path: ROUTES.aiAssessmentAdminUser,
      element: (
        <RequirePermission perm="assessment.analytics.view" redirectTo={ROUTES.aiAssessment}>
          <Suspense fallback={<Loader />}>
            <AssessmentUserDetail />
          </Suspense>
        </RequirePermission>
      ),
    },
  ],
};
